import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormGetAllService } from '../../services';

export const fetchFormGetAll = createAsyncThunk(
    'formGetAll/fetchFormGetAll',
    async () => {
        const response = await FormGetAllService()
        return response.result
    }
);

const formGetAllSlice = createSlice({
    name: 'formGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formGetAllSlice.reducer;
